"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.aiFormAnalyzer.name': 'AI Form Analyzer',
    'tools.aiFormAnalyzer.formSentByUser': 'I have submitted the form.',
};
